import { render, staticRenderFns } from "./profile-detail.vue?vue&type=template&id=7e25d53c&scoped=true&"
import script from "./profile-detail.vue?vue&type=script&lang=js&"
export * from "./profile-detail.vue?vue&type=script&lang=js&"
import style0 from "./profile-detail.vue?vue&type=style&index=0&id=7e25d53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e25d53c",
  null
  
)

export default component.exports